import { logError } from 'utils/log';

import type { PromptExitAdditionalContent } from 'types';

type Handler = (h?: () => void) => void | Promise<void>;

function saveSOVReport() {
  const saveReportButton = document.querySelector('.js-sov-header__button-save-report');

  if (saveReportButton && saveReportButton instanceof HTMLElement) {
    saveReportButton.click();
  }
}

const actionsMap = {
  saveSOVReport
};

export function getActionByName(actionName: string): Handler | undefined {
  return actionsMap[actionName];
}

export const setActionByName = (actionName: string, action: Handler): void => {
  actionsMap[actionName] = action;
};

export function enableNavigation() {
  const prompt = document.querySelector('.js-prompt-exit-page');

  if (prompt) {
    prompt.removeAttribute('class');
  }
}

export const getPromptExitAdditionalContent = (input: string, handler: () => void): PromptExitAdditionalContent | null => {
  try {
    if (!input) {
      return null;
    }

    const parsed = JSON.parse(input);

    if (!parsed) {
      return null;
    }

    const actions = parsed.buttons?.map(b => b.actionName) ?? undefined;
    (actions ?? []).forEach(actionName => {
      const action = getActionByName(actionName);
      setActionByName(actionName, () => action && action(handler));
    });

    return parsed;
  } catch (error) {
    logError(error);

    return null;
  }
};
